<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null,'ADD')">
                添加
            </Button>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row,'EDIT')">编辑</a>
                <a class="opt-txt" @click="handleOperation(row,'DELETE')">删除</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>
        <Modal v-model="modalVisible" :title="modalTitle">
            <Spin size="large" fix v-if="modalLoading"></Spin>
            <Form ref="baseForm" :model="modalForm" :label-width="100">
                <FormItem label="模板名称" prop="templateName" :rules="[rules.required]">
                    <Input v-model="modalForm.templateName" placeholder="模板名称"></Input>
                </FormItem>
                <FormItem label="编号" prop="code" :rules="[rules.required]">
                    <Input v-model="modalForm.code" placeholder="编号"></Input>
                </FormItem>
                <FormItem label="内容" prop="content" :rules="[rules.required]">
                    <Input type="textarea" v-model="modalForm.content" placeholder="内容"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="modalVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </div>
        </Modal>

    </Card>
</template>
<script>
    import iSms from '@/module/base/api/iSms'
    import tableHelper from '@/mixins/tableHelper';
    import rules from '@/libs/rules';
    import _don from '@/libs/doson'

    const modalFormTemplate = {
        id: null,
        templateName: null,
        code: null,
        content: null
    };

    export default {
        name: "sms_template",
        mixins: [tableHelper],
        components: {
        },
        data() {
            return {
                rules,
                query:{
                    code:null,
                },

                tableColumns: [
                    {title: '序号', key: 'idx', width: 80},
                    {title: '模板名称', key: 'templateName', width: 160},
                    {title: '编号', key: 'code', width: 120},
                    {title: '内容', key: 'content'},
                    {title: '添加时间', key: 'addTime', width: 180},
                    {title: '操作', slot: 'operation', width: 160}
                ],

                modalTitle:'添加模板',
                modalVisible:false,
                modalLoading:false,
                modalForm:_don.cloneWithModal(modalFormTemplate),
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                iSms.templateList(this.page, this.query).then(res => {
                    var i = 1
                    this.tableList = res.content.map(e => {
                        e.idx = (this.page.page-1)*this.page.size+i++
                        return e
                    });
                    this.total = res.totalElements
                }).loadingSwitch(this, 'tableLoading');
            },
            async handleOperation(row, type) {
                if (type === 'ADD') {
                    this.$refs.baseForm.resetFields();
                    this.modalVisible = true
                    this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'EDIT') {
                    this.$refs.baseForm.resetFields();
                    this.modalVisible = true
                    _don.cloneWithModal(modalFormTemplate, this.modalForm, row);
                    //this.modalForm = _don.cloneWithModal(modalFormTemplate)
                    return;
                }
                if (type === 'DELETE') {
                    this.$Modal.confirm({
                        title: '提示',
                        content: `将删除该模板”，确认继续？`,
                        onOk: () => {
                            iSms.templateDelete(row.id).then(() => {
                                this.$Message.success('操作成功');
                                this.getTableData();
                            }).loadingSwitch(this, 'tableLoading');
                        }
                    });
                    return;
                }
            },
            handleSubmit() {
                this.$refs.baseForm.validate(val => {
                    if (!val) return;
                    if(this.modalForm.id){
                        iSms.templateUpdate(this.modalForm).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData()
                            this.modalVisible = false
                        });
                    } else {
                        iSms.templateAdd(this.modalForm).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData()
                            this.modalVisible = false
                        });
                    }

                });
            }
        }
    }
</script>

<style scoped lang="less">

</style>
